import AccountApi from '@/api/account'

export default {
  methods: {
    async getTransitionUrl (transitionUrl) {
      let targetUrl = null
      if (transitionUrl) {
        const transitionUrlTmp = new URL(transitionUrl)
        const transitionDomain = transitionUrlTmp.origin // http://[domain]を取得

        const myServices = await AccountApi.top() // 利用可能サービス

        for (const service of myServices) {
          const serviceUrl = new URL(service.serviceUrl)
          if (transitionDomain === serviceUrl.origin) {
            targetUrl = transitionUrl
            break
          }
        }
      }
      return targetUrl
    }
  }
}
